export const getDaysArr = (day1, day2) => {
  var st = day1.getDate();
  var et = day2.getDate();
  var retArr = [];
  while (st.getTime() != et.getTime()) {
    retArr.push(st.getYMD());

    // 取得开始日期的天
    var tempDate = st.getDate();
    // 将开始日期st指向构造出的新的日期
    // 新的日期较之前的日期多加一天
    st = new Date(st.getFullYear(), st.getMonth(), st.getDate() + 1);
  }

  // 将结束日期的天放进数组
  retArr.push(et.getYMD());
  return retArr;
};

// 给Date对象添加getYMD方法，获取字符串形式的年月日
Date.prototype.getYMD = function() {
  var retDate = this.getFullYear() + '-';
  if (this.getMonth() < 10) {
    if (parseInt(this.getMonth()) == 0) {
      var retDate = this.getFullYear() - 1 + '-';
      retDate += 12 + '-';
    } else {
      retDate += '0' + this.getMonth() + '-';
    }
  } else {
    retDate += this.getMonth() + '-';
  } // 获取年份。
  // 获取月份。
  // retDate += this.getDate();
  if (this.getDate() < 10) {
    retDate += '0' + this.getDate();
  } else {
    retDate += this.getDate();
  } // 获取日。
  return retDate; // 返回日期。
};
// 给String对象添加getDate方法，使字符串形式的日期返回为Date型的日期
String.prototype.getDate = function() {
  var strArr = this.split('-');
  var setArrYeas = '';
  // if(parseInt(this.getMonth()) == 0){ setArrYeas =strArr[0]-1}else{setArrYeas = strArr[0]}
  var date = new Date(strArr[0], strArr[1], strArr[2]);
  return date;
};



// WEBPACK FOOTER //
// ./src/lib/GetDays.js